'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import Image from 'next/image';
import Button from '@/app/cc/_component/ui/common/Button/Button';
import styles from '@/app/cc/_component/ui/layout/Layout.module.scss';
import { useOpenModal } from '@/app/cc/_hooks/useOpenModal';
import { sendGA } from '@/app/cc/_util/sendGA';
import HeaderBackButton from './HeaderBackButton';
export default function Header(t0) {
  const $ = _c(9);
  const {
    className
  } = t0;
  const openModal = useOpenModal();
  let t1;
  if ($[0] !== className) {
    t1 = clsx(styles.header, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HeaderBackButton />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={styles.left}>{t2}<h1 className={styles.logo}><button type="button" onClick={_temp} aria-label={"\uC774\uC2E4\uC7A5 \uC548\uC2EC\uCF00\uC5B4 \uD648"} className={styles.logoLink}><Image src="/cc/image/logo.svg" alt={"\uC774\uC2E4\uC7A5 \uC548\uC2EC\uCF00\uC5B4"} fill={true} /></button></h1></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== openModal) {
    t4 = <div className={styles.inner}>{t3}<Button size="md" color="primary" onClick={() => {
        sendGA("headerReserveClick");
        openModal("consultation");
      }}>상담 신청하기</Button></div>;
    $[4] = openModal;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t4) {
    t5 = <header className={t1}>{t4}</header>;
    $[6] = t1;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
function _temp() {
  return window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}